// extracted by mini-css-extract-plugin
module.exports = {"root":"FormSection_root"};